import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect, disconnect } from '@/utils/notificationsSocket';
import { fetchNotifications, fetchUnreadCount } from '@/store/actions/notifications';

/**
 * Opens the realtime notifications WebSocket while the user is authenticated
 * and loads the initial history + unread count over REST. Mount once, high in
 * the authenticated layout tree.
 */
export const useNotificationsSocket = (): void => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const accessToken = useSelector((state: any) => state.auth.access_token);
  const currentEmployee = useSelector((state: any) => state.auth.current_employee);

  useEffect(() => {
    if (!isLoggedIn || !accessToken) return;

    dispatch(fetchNotifications());
    dispatch(fetchUnreadCount());
    connect();

    return () => {
      disconnect();
    };
    // Reconnect + refetch when the token or active employee changes.
  }, [isLoggedIn, accessToken, currentEmployee, dispatch]);
};
